import templateUrl from './availableInSubscriptionComponent.html';

class AvailableInSubscriptionCtrl {
  subscriptions = ['Free', 'Premium', 'Business'];

  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
  }
}

export default {
  templateUrl,
  controllerAs: 'ctrl',
  controller: AvailableInSubscriptionCtrl,
  bindings: {
    feature: '<',
  },
};
